export const admin_Loading_status = "admin_Loading_status";

export const admin_Get_Success_status = "admin_Get_Success_status";

export const admin_Error_status = "admin_Error_status";

export const admin_Delete_Success_status = "admin_Delete_Success_status"

export const admin_Update_Success_status = "admin_Update_Success_status"
